<loading-contents *ngIf="websites == null"></loading-contents>
<div class="main-contents" *ngIf="websites != null">
  <div class="webslider">    
      <owl-carousel-o [options]="customOptions">
          <ng-template carouselSlide>
              <div class="slide">
                  <img src="../../assets/images/websites/web-slider-01.jpg">
              </div>
          </ng-template>
          <ng-template carouselSlide>
              <div class="slide">
                  <img src="../../assets/images/websites/web-slider-02.jpg">
              </div>
          </ng-template>
          <ng-template carouselSlide>
              <div class="slide">
                  <img src="../../assets/images/websites/web-slider-03.jpg">
              </div>
          </ng-template>   
          <ng-template carouselSlide>
              <div class="slide">
                  <img src="../../assets/images/websites/web-slider-04.jpg">
              </div>
          </ng-template>
          <ng-template carouselSlide>
              <div class="slide">
                  <img src="../../assets/images/websites/web-slider-05.jpg">
              </div>
          </ng-template>   
      </owl-carousel-o>
  </div>
  <div class="contents" *ngIf="websites != null">
    <div class="container">
      <h1 class="page-title icon-screen">Web development</h1>

      <!-- ✅ 更新后的简介 -->
      <p>
        I build modern, scalable, and user-friendly web applications with a strong focus on
        eCommerce and business workflows. I specialize in full-stack development (React/Angular
        + Node.js/Express/PHP) and seamless integrations across Shopify, Magento, NetSuite,
        WordPress, Drupal, ShipStation, WindWard, and WebShop Manager—covering UI/UX, API
        integrations, data synchronization, and performance optimization.
      </p>

      <div class="row">
        <div class="col-xs-6 col-md-6 col-sm-6">
          <h5>I can help you</h5>
          <ul>
            <li>Full-stack web apps (React/Angular, Node.js/Express, PHP)</li>
            <li>eCommerce builds & migrations (Shopify, Magento, NetSuite)</li>
            <li>Theme/plugin development & headless storefronts</li>
            <li>API integrations (REST/GraphQL, ShipStation, WindWard, WSM)</li>
            <li>Custom BMS modules (orders, purchases, inventory, finance)</li>
            <li>Responsive UI/UX, accessibility, cross-browser compatibility</li>
            <li>Performance, SEO, and site reliability improvements</li>
          </ul>
        </div>

        <div class="col-xs-6 col-md-6 col-sm-6">
          <h5>Experience And Skills</h5>
          <ul>
            <li>JavaScript/TypeScript · React · Angular · Backbone</li>
            <li>Node.js · Express · PHP · MySQL/MariaDB</li>
            <li>HTML5/CSS3 · Tailwind/Bootstrap · Responsive design</li>
            <li>Shopify · Magento · NetSuite · WordPress · Drupal</li>
            <li>API design/integration · Webhooks · Auth · Data sync/ETL</li>
            <li>Testing mindset from QA background (unit/E2E)</li>
            <li>Performance tuning · Security best practices · Git/CI</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <div class="items-wrapper padding-top-30" *ngIf="websites != null">
      <div class="container">
          <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li class="nav-item">
              <a class="nav-link active" id="home-tab" data-toggle="tab" href="#all" role="tab" aria-controls="All"
                aria-selected="true">All<span class="total">( {{total}} )</span></a>
            </li>
            <li class="nav-item">
              <a class="nav-link" id="wordpress-tab" data-toggle="tab" href="#wordpress" role="tab" aria-controls="wordpress"
                aria-selected="false">WordPress<span class="total">( {{objectKeys(wordpress).length}} )</span></a>
            </li>
            <li class="nav-item">
              <a class="nav-link" id="magento-tab" data-toggle="tab" href="#magento" role="tab" aria-controls="magento"
                aria-selected="false">Magento<span class="total">( {{objectKeys(magento).length}} )</span></a>
            </li>
            <li class="nav-item">
              <a class="nav-link" id="netsuite-tab" data-toggle="tab" href="#netsuite" role="tab" aria-controls="netsuite"
                aria-selected="false">NetSuite<span class="total">( {{objectKeys(netsuite).length}} )</span></a>
            </li>
            <li class="nav-item">
              <a class="nav-link" id="drupal-tab" data-toggle="tab" href="#drupal" role="tab" aria-controls="drupal"
                aria-selected="false">Drupal<span class="total">( {{objectKeys(drupal).length}} )</span></a>
            </li>
            <li class="nav-item">
              <a class="nav-link" id="dotnet-tab" data-toggle="tab" href="#dotnet" role="tab" aria-controls="dotnet"
                aria-selected="false">.Net<span class="total">( {{objectKeys(dotnet).length}} )</span></a>
            </li>
          </ul>
            
          <div class="tab-content">
            <div class="tab-pane active" id="all" role="tabpanel" aria-labelledby="home-tab">
                <div class="row" *ngIf="websites">
                    <div class="col-lg-3 col-xs-6 col-md-3 col-sm-6" (click)="onSelect(website)"  *ngFor="let website of websites">
                        <!-- <p class="name">{{website.title}}</p>
                        <p class="Link">{{website.site_link}}</p>
                        <p class="Link">{{website.item_category}}</p>
                        <p class="Link">{{website.site_description}}</p>
                        <p class="Link">{{website.site_images}}</p>
                        <p class="Link">{{website.thumbnail_image}}</p>
                        <p class="Link">{{website.url}}</p> -->
                        <div class="card">
                            <div class="card-image">
                              <img src="../../assets/images/websites/thumbnail/{{website.thumbnail_image}}" class="card-img-top" alt="{{website.title}}">
                            </div>                            
                            <div class="card-body">
                              <div class="body-wrapper">                                
                                <div class="siteTitle">
                                  <h6>{{website.title}}</h6>
                                  <span>Build by: {{website.item_category}}</span>
                                </div>
                              </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="tab-pane" id="wordpress" role="tabpanel" aria-labelledby="profile-tab">
                <div class="row" *ngIf="wordpress">
                    <div class="col-lg-3 col-xs-6 col-md-3 col-sm-6" (click)="onSelect(website)" *ngFor="let website of wordpress">
                      <div class="card">
                        <div class="card-image">
                          <img src="../../assets/images/websites/thumbnail/{{website.thumbnail_image}}" class="card-img-top" alt="{{website.title}}">
                        </div>                            
                        <div class="card-body">
                          <div class="body-wrapper">                                
                            <div class="siteTitle">
                              <h6>{{website.title}}</h6>
                              <span>Build by: {{website.item_category}}</span>
                            </div>
                          </div>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
            <div class="tab-pane" id="magento" role="tabpanel" aria-labelledby="magento-tab">
                <div class="row" *ngIf="magento">
                    <div class="col-lg-3 col-xs-6 col-md-3 col-sm-6" (click)="onSelect(website)" *ngFor="let website of magento">
                      <div class="card">
                        <div class="card-image">
                          <img src="../../assets/images/websites/thumbnail/{{website.thumbnail_image}}" class="card-img-top" alt="{{website.title}}">
                        </div>                            
                        <div class="card-body">
                          <div class="body-wrapper">                                
                            <div class="siteTitle">
                              <h6>{{website.title}}</h6>
                              <span>Build by: {{website.item_category}}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                </div>
            </div>
            <div class="tab-pane" id="netsuite" role="tabpanel" aria-labelledby="netsuite-tab">
                <div class="row" *ngIf="netsuite">
                    <div class="col-lg-3 col-xs-6 col-md-3 col-sm-6" (click)="onSelect(website)" *ngFor="let website of netsuite">
                      <div class="card">
                        <div class="card-image">
                          <img src="../../assets/images/websites/thumbnail/{{website.thumbnail_image}}" class="card-img-top" alt="{{website.title}}">
                        </div>                            
                        <div class="card-body">
                          <div class="body-wrapper">                                
                            <div class="siteTitle">
                              <h6>{{website.title}}</h6>
                              <span>Build by: {{website.item_category}}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                </div>
            </div>
            <div class="tab-pane" id="drupal" role="tabpanel" aria-labelledby="drupal-tab">
                <div class="row" *ngIf="drupal">
                    <div class="col-lg-3 col-xs-6 col-md-3 col-sm-6" (click)="onSelect(website)" *ngFor="let website of drupal">
                      <div class="card">
                        <div class="card-image">
                          <img src="../../assets/images/websites/thumbnail/{{website.thumbnail_image}}" class="card-img-top" alt="{{website.title}}">
                        </div>                            
                        <div class="card-body">
                          <div class="body-wrapper">                                
                            <div class="siteTitle">
                              <h6>{{website.title}}</h6>
                              <span>Build by: {{website.item_category}}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                </div>
            </div>
            <div class="tab-pane" id="dotnet" role="tabpanel" aria-labelledby="dotnet-tab">
                <div class="row" *ngIf="dotnet">
                    <div class="col-lg-3 col-xs-6 col-md-3 col-sm-6" (click)="onSelect(website)" *ngFor="let website of dotnet">
                      <div class="card">
                        <div class="card-image">
                          <img src="../../assets/images/websites/thumbnail/{{website.thumbnail_image}}" class="card-img-top" alt="{{website.title}}">
                        </div>                            
                        <div class="card-body">
                          <div class="body-wrapper">                                
                            <div class="siteTitle">
                              <h6>{{website.title}}</h6>
                              <span>Build by: {{website.item_category}}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                </div>
            </div>
          </div>
      </div>
  </div>
</div>
